<template>
  <div class="app-inner-layout__sidebar card">
    <slot name="client-filter">
      <div class="app-inner-layout__top-pane p-3">
        <div class="pane-right pt-3">
          <PageNav class="justify-content-end" :config="query.client" :display="{ total: false, first: false, last: false, input: false }" @changeValue="changeClientPage()" />
        </div>
      </div>
    </slot>

    <div class="bg-white">
      <div class="app-inner-layout__sidebar-body scrollbar" ref="clientSidebar">
        <div v-if="currentClients.length == 0" class="h5 text-center text-secondary">No customers</div>
        <ul v-else class="nav flex-column">
          <li v-for="client in currentClients" :key="client.id" class="item">
            <button type="button" tabindex="0" :class="[client.id == query.client.selected.id ? 'active' : '', 'dropdown-item']">
              <div class="widget-content p-0" @click="chooseClient(client)">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left mr-3">
                    <img width="42" class="rounded-circle" :src="client.thumbnail" />
                  </div>
                  <div class="widget-content-left">
                    <div class="widget-heading">{{ client.title }}</div>
                    <div class="widget-subheading">
                      <p class="client-excerpt mb-0">{{ client.meta.size }} | {{ client.meta.user_name }}</p>
                      <p class="client-excerpt mb-0">{{ client.meta.price }} | {{ client.status }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="app-inner-layout__content card">
    <div class="table-responsive" ref="messageWrapper">
      <div class="app-inner-layout__top-pane">
        <div class="pane-left">
          <div class="mobile-app-menu-btn">
            <button type="button" class="hamburger hamburger--elastic">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
          <div class="avatar-icon-wrapper mr-2">
            <div class="avatar-icon avatar-icon-xl rounded">
              <img width="82" :src="conversation.buyer.thumbnail" />
            </div>
          </div>
          <h4 class="mb-0 text-nowrap">
            {{ conversation.buyer.user_name }}
          </h4>
        </div>
      </div>
      <div class="chat-wrapper scrollbar" ref="messegerContent">
        <div class="clearfix">
          <div v-for="message in conversation.messages" :key="message.id" :class="[message.me == true ? 'float-right' : '']">
            <div :class="[message.me == true ? 'chat-box-wrapper-right' : '', 'chat-box-wrapper flex-wrap']">
              <div class="avatar-icon-wrapper">
                <div class="avatar-icon-wrapper ml-1">
                  <div class="avatar-icon avatar-icon-lg rounded">
                    <img v-if="message.me != true" :src="conversation.buyer.thumbnail" />
                    <img v-else :src="noThumbnail" />
                  </div>
                </div>
              </div>
              <div class="chat-message">
                <div class="chat-box" v-html="message.text"></div>
                <small class="opacity-6">
                  <i class="fa fa-calendar-alt mr-1"></i>
                  <span v-html="$util.timestampToDateTime(message.date_created)"></span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center input-message">
        <div class="position-relative">
          <span v-if="query.conversation.attachment.name" @click="previewImage(query.conversation.attachment.src)" class="image-message">
            <span>{{ query.conversation.attachment.name }}</span>
          </span>
        </div>
        <div class="position-relative">
          <textarea type="text" name="msg" class="form-control scrollbar" :value="query.conversation.message" placeholder="Send message" @change="changeMessage($event.currentTarget.value)"></textarea>
          <svg class="submit" height="20px" width="20px" viewBox="0 0 24 24" @click="sendMessage()">
            <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill-rule="evenodd" stroke="none"></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import PageNav from '@/components/PageNav.vue'
//import ImagePreviewModal from "@/components/Modal/ImagePreview";

export default {
  components: {
    PageNav
    //ImagePreviewModal,
  },
  mixins: [Event],
  data() {
    return {
      noThumbnail: '@/../assets/imgs/shop-icon.png',
      query: {
        client: {
          total: 0,
          limit: 10,
          page: 1,
          offset: '',
          selected: {
            id: ''
          }
        },
        conversation: {
          message: '',
          attachment: {
            name: false,
            src: false
          }
        }
      },
      clients: {},
      conversation: {
        buyer: {
          id: '',
          thumbnail: this.noThumbnail,
          user_name: 'No Custommer'
        },
        messages: [],
        enabled: true
      }
    }
  },
  computed: {
    accountId() {
      return this.config?.query?.selected?.id || ''
    },
    currentClients() {
      return this.clients?.[this.query?.client?.page] || {}
    }
  },
  created() {
    this.initClient()
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)

    this.$refs.messegerContent.addEventListener('scroll', () => {
      if (this.conversation.messages.length > 0) {
        let element = this.$refs.messegerContent
        if (element.scrollTop <= 50) {
          this.loadMoreMessage()
        }
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.$refs.clientSidebar.style.height = window.innerHeight - this.$util.getOffset(this.$refs.clientSidebar).top + 'px'
      this.$refs.messegerContent.style.height = window.innerHeight - this.$util.getOffset(this.$refs.messegerContent).top - 80 + 'px'
    },
    changeClientPage(value) {
      this.query.client.page = value
      this.initClient()
    },
    initClient() {
      let data = {
        offset: this.query.client.offset
      }

      if (String(this.accountId).length > 0 && !_.isObjectLike(this.clients[this.query.client.page])) {
        this.$util.get(`account-message/get-client/${this.accountId}`, data, this.$refs.clientSidebar, {
          done: (response) => {
            if (!_.isArray(response.items)) return
            this.query.client = Object.assign(this.query.client, {
              total: response.total,
              offset: response.offset
            })
            this.clients[this.query.client.page] = response.items
          }
        })
      } else {
        this.$util.notify({
          status: 'warning',
          text: 'Please choose account!'
        })
      }
    },
    chooseClient(client) {
      this.query.client.selected = client
      this.initMessage()
    },
    initMessage() {
      let data = {
        client_id: this.query.client.selected.id
      }

      if (String(this.accountId).length > 0 && String(data.client_id).length > 0) {
        this.$util.get(`account-message/get-message/${this.accountId}`, data, this.$refs.messageWrapper, {
          done: (response) => {
            if (!_.isArray(response.items)) return
            this.conversation = Object.assign(this.conversation, {
              messages: response.items,
              buyer: response.buyer,
              enabled: response.enabled
            })

            /* if (response.items.length > 0) {
              let element = this.$refs.messegerContent;
              let scrollInterval = setInterval(() => {
                if (element.scrollHeight > 0) {
                  element.scrollTo(0, element.scrollHeight - element.clientHeight);
                  clearInterval(scrollInterval);
                }
              }, 50);
            } */
          }
        })
      } else {
        this.$util.notify({
          status: 'warning',
          text: 'Please choose account and customer!'
        })
      }
    }
    /* dropDownMessageChange(value) {
      this.query.client.tagSelected = value;
    },
    changeSearchClient(value) {
      this.query.client.search = value;
    },
    filterClientSubmit() {
      this.query.client.page = 1;
      this.initClient();
    }, 
    
    loadMoreMessage() {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: this.query.client.selected,
        buyer_id: this.conversation.buyer.user_id,
        offset: 0,
      };

      if (String(data.account_id).length > 0 && String(data.client_id).length > 0) {
        let messages = Object.values(this.store.getter('conversation.messages'));
        data.offset = messages[0].priority;
        if (data.offset > 1) {
          this.$util.post(
            "account-message/load-more",
            data,
            this.$refs.messageWrapper,
            {
              done: (response) => {
                if (!_.isArray(response.messages)) return;
                messages = messages.concat(Object.values(response.messages));
                messages = this.$util.sort(messages);
                this.store.commit("conversation.messages", messages);
              }
            }
          );
        }
      }
    },
    conversationAction(client_id, action) {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: client_id,
        tag: action,
      };
      this.$util.post("account-message/conversation-action", data, this.$el, {
        done: (response) => {
          if (response.status == "success") {
            let clients = this.store.getter('clients');
            let accounts = this.store.getter('accounts');

            if (!_.isArray(clients)) {
              clients = [];
            }
            if (!_.isArray(accounts)) {
              accounts = [];
            }
            clients.forEach((client) => {
              if (client.id == client_id) {
                if (action == "readed") {
                  client.readed = true;
                } else if (action == "unread") {
                  client.readed = false;
                }
                return false;
              }
            });
            this.store.commit("clients", clients);

            accounts.forEach((account, index) => {
              if (account.id == data.account_id) {
                this.store.commit(
                  `accounts.${index}.notification`,
                  response.notification
                );
                return false;
              }
            });
          }
        }
      });
    },
    changeMessage(value) {
      this.query.conversation.message = value;
    },
    previewImage(url) {
      this.store.commit("modal", {
        _visible: true,
        src: url,
      });
    },
    uploadImage(e) {
      let $this = e.currentTarget;
      let file = $this.files[0];
      this.query.conversation.attachment = {
        name: "Uploading...",
        id: false,
        src: URL.createObjectURL(file),
      };
      this.$util.uploadFile(
        file,
        this.$refs.imageMessage,
        {
          done: (response) => {
            if (response.status == "success" && !_.isUndefined(response.image)) {
              response.image.src = URL.createObjectURL(file);
              response.image.name = file.name;
              this.query.conversation.attachment = response.image;
            } else {
              this.query.conversation.attachment = {
                name: "Upload Fail",
                id: false,
                src: false,
              };
            }
          },
          error: () => {
            this.query.conversation.attachment = {
              name: "Upload Fail",
              id: false,
              src: false,
            };
          },
        },
        {
          account_id: this.query.accounts.selected,
          client_id: this.query.client.selected,
          uploadUrl: this.$util.options.api.upload,
          action: "account-message/upload-attachment",
        }
      );
    },
    sendMessage() {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: this.query.client.selected,
        message: this.query.conversation.message,
        attachment: this.query.conversation.attachment,
      };
      this.$util.post("account-message/send-message", data, this.$el, {
        done: (response) => {
          if (!_.isObjectLike(response.message)) return;
          let messages = this.store.getter('conversation.messages');
          if (!_.isArray(messages)) {
            messages = [];
          }
          if (!_.isUndefined(response.message.id)) {
            messages.push(response.message);
            this.store.commit("conversation.messages", messages);
            this.query.conversation.message = "";
            let element = this.$refs.messegerContent;
            let scrollInterval = setInterval(() => {
              if (element.scrollHeight > 0) {
                element.scrollTo(0, element.scrollHeight - element.clientHeight);
                clearInterval(scrollInterval);
              }
            }, 50);
          }
        }
      });
    }, */
  },
  props: {
    config: Object
  },
  watch: {
    accountId() {
      this.initClient()
    }
  }
}
</script>
<style lang="scss">
.scroll-to-top {
  display: none;
}
.page-account-message-container {
  margin: -30px;
  border-top: 1px solid #e9ecef;
  .app-inner-layout__top-pane {
    .pane-right.attachment {
      > a {
        color: #fff;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .app-inner-layout__wrapper {
    min-height: 0;
    .app-inner-layout__sidebar.card {
      width: 300px;
      flex: 0 0 300px;
      border-left: 0;
      .displaying-num {
        display: none;
      }
      .tablenav-pages {
        display: flex;
        justify-content: center;
        float: none;
      }
      .dropdown-item {
        min-height: 80px;
        border-bottom: 1px solid #efefef;
      }
      .client-excerpt {
        max-width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .message-count {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 22px;
        height: 22px;
        background: #c50000;
        border-radius: 50%;
        border: 1px solid #fff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .app-inner-layout__sidebar-body {
        overflow: auto;
        overflow-x: hidden;
        .dropdown-item {
          position: relative;
          &.active {
            .icon-wrapper {
              i {
                color: #fff !important;
              }
            }
          }
        }
        .item {
          &.item-readed,
          &.item-unread {
            > .dropdown-item {
              padding: 0 !important;
              min-height: 0 !important;
              > .widget-content {
                min-height: 80px;
                padding: 0.4rem 1.5rem !important;
                display: flex;
              }
            }
            .dropdown {
              position: absolute;
              right: 0;
              z-index: 999999999;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              > div.icon-wrapper {
                width: 28px;
                height: 28px;
                padding: 5px;
              }
              .dropdown-menu {
                left: -15px !important;
              }
              i {
                color: #333;
                font-size: 16px;
              }
              a {
                display: block;
                padding: 10px 20px;
                color: #333;
                &:hover {
                  color: #fff;
                  background-color: #3f6ad8;
                }
              }
            }
          }
        }

        .item.item-readed {
          .widget-content {
            opacity: 0.7;
          }

          /* .fa-fw {
            content: ;
            &:hover {
              content: ;
            }
          } */
        }
        .item.item-unread {
          .dropdown-item {
            background: #c5e3ff;
            border-bottom: 1px solid #2196f3;
          }
          .widget-content {
            opacity: 1;
          }
          .widget-heading {
            opacity: 1;
            font-weight: 500;
          }
          .widget-subheading {
            opacity: 1;
          }
          .dropdown {
            i {
              color: #333;
            }
          }
        }
      }
    }
    .app-inner-layout__content.card {
      &.has-overlay {
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 999;
          background: #fff;
          opacity: 0.5;
        }
      }
      .chat-wrapper {
        overflow: auto;
        > div > div {
          clear: both;
          max-width: 90%;
        }
        .chat-box {
          display: block;
        }
        .chat-message {
          flex: 1;
        }
        .message-image-wrapper {
          display: flex;
          order: 0;
          width: 100%;
          margin-bottom: 5px;
          .img-preview {
            width: 80px;
            height: 80px;
            margin-left: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: 1px solid #dfdfdf;
              border-radius: var(--border-radius, 0.25rem);
            }
          }
        }
        .float-right .message-image-wrapper {
          justify-content: flex-end;
        }
        .chat-box-wrapper.chat-box-wrapper-right {
          justify-content: flex-end;
          .avatar-icon-wrapper {
            order: 2;
          }
          .chat-message {
            order: 1;
          }
        }
      }
      .input-message {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #fff;
        margin: 10px 0px;
        > div {
          width: 100%;
          padding: 0 20px;
        }
        textarea {
          padding-right: 80px;
          background: #f5f5f5;
          border: 0;
          border-radius: var(--border-radius, 0.25rem);
          flex: 1;
          font-size: 14px;
        }
        .submit {
          position: absolute;
          cursor: pointer;
          top: calc(50% - 10px);
          right: 35px;
          fill: #ccc;
          z-index: 9;
          top: 0;
          height: 40px;
          &:hover {
            fill: #3f6ad8;
          }
        }
        .image-message {
          background: #f5f5f5;
          padding: 5px 15px;
          margin-bottom: 5px;
          display: inline-block;
          border-radius: 100px;
          max-width: 100%;
          cursor: pointer;
          user-select: none;
          span {
            white-space: nowrap;
            overflow: hidden;
            display: block;
          }
        }
        .add-images {
          position: absolute;
          width: 40px;
          height: 36px;
          right: 56px;
          cursor: pointer;
          top: 0;
          margin: 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          .background-svg {
            fill: #ccc;
          }
          .border-svg {
            stroke: #ccc;
          }
          &:hover {
            .background-svg {
              fill: #3f6ad8;
            }
            .border-svg {
              stroke: #3f6ad8;
            }
          }
        }
      }
    }
  }
}
</style>
